module.exports = __webpack_public_path__ + "front/img/70.bfbc0796.png";